"use strict";

var _require = require('../helpers/constants'),
    URI = _require.URI;

var HTTP_METHODS = require('../helpers/http_methods');

var _require2 = require('../helpers/request_handler'),
    requestHandler = _require2.requestHandler;

var userMethods = function userMethods(bucket_config) {
  return {
    getUsers: function getUsers() {
      var endpoint = "".concat(URI, "/buckets/").concat(bucket_config.slug, "/users");
      return requestHandler(HTTP_METHODS.GET, endpoint, null);
    },
    getUser: function getUser(params) {
      var endpoint = "".concat(URI, "/buckets/").concat(bucket_config.slug, "/users/").concat(params.id);
      return requestHandler(HTTP_METHODS.GET, endpoint, null);
    },
    addUser: function addUser(params) {
      var endpoint = "".concat(URI, "/buckets/").concat(bucket_config.slug, "/users");
      return requestHandler(HTTP_METHODS.POST, endpoint, params);
    }
  };
};

module.exports = userMethods;